import React, { useContext, useState, useEffect, useRef } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import Cropper from "react-cropper";
import axios from "axios";
import { imagePath, urls } from "../../Url";
import storage from "../../Assets/js/Global";
import WeightModal from "../../modals/WeightModal";
import HeightModal from "../../modals/HeightModal";
import WaistModal from "../../modals/WaistModal";
import { Check, Mail, Activity, Stethoscope } from "lucide-react";
import { images } from "../../Assets/images";
import PhoneNumberInput from "../../Components/PhoneNumberInput";
// import Calendar from "../../Components/Calender";
import Select from "react-select";
import { getData } from "country-list";
import VerifyOtpModal from "../../modals/VerifyOtpModal";

const UserProfileEdit = () => {
  const {
    getUserDetails,
    userDetails,
    updateUserDetails,
    uploadCropImg,
    translatedLabels,
    getWellnessCat,
    wellnessCat,
    // showCalendar,
    // setShowCalendar,
    // calendarRef,
    getTimeZone,
    timeZone,
    is4Life,
    fourLifeEmailOTP,
    signupData,
    updateSignupData,
    servings,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const screenLabels = translatedLabels?.common;
  const commonLabel = translatedLabels?.common;
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedTimeZone, setSelectedTimeZone] = useState(null);
  const [diabetesYesNo, setDiabetesYesNo] = useState("");
  const [diabetesType, setDiabetesType] = useState("");
  const [profileData, setProfileData] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showCropModal, setShowCropModal] = useState(false);
  const [showWeightModal, setWeightModal] = useState(false);
  const [showHeightModal, setShowHeightModal] = useState(false);
  const [showWaistModal, setShowWaistModal] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [cropper, setCropper] = useState(null);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);

  // const countryOptions = (() => {
  //   const countries = getData().map((country) => ({
  //     value: country.code,
  //     label: country.name,
  //   }));
  //   const usa = countries.find((c) => c.value === "US");
  //   const otherCountries = countries
  //     .filter((c) => c.value !== "US")
  //     .sort((a, b) => a.label.localeCompare(b.label));
  //   return usa
  //     ? [usa, ...otherCountries]
  //     : countries.sort((a, b) => a.label.localeCompare(b.label));
  // })();

  const countryOptions = (() => {
    const countries = (getData() || [])
      .filter((c) => c && c.code && c.name)
      .map((country) => ({
        value: country.code,
        label: country.name
          .replace(/\s*\(.*?\)\s*/g, " ")
          .replace(/\s+/g, " ")
          .trim(),
      }));

    const usa = countries.find((c) => c.value === "US");

    const otherCountries = countries
      .filter((c) => c.value !== "US")
      .sort((a, b) => a.label.localeCompare(b.label));

    return usa
      ? [usa, ...otherCountries]
      : countries.sort((a, b) => a.label.localeCompare(b.label));
  })();

  const SKIN_TONES = [
    {
      key: "Very Light",
      v: screenLabels?.skin_tone_very_light?.label_value || "Very Light",
      c: "#F5D5C0",
    },
    {
      key: "Light",
      v: screenLabels?.skin_tone_light?.label_value || "Light",
      c: "#E8B89A",
    },
    {
      key: "Light Medium",
      v: screenLabels?.skin_tone_light_medium?.label_value || "Light Medium",
      c: "#D69875",
    },
    {
      key: "Medium",
      v: screenLabels?.skin_tone_medium?.label_value || "Medium",
      c: "#B97B57",
    },
    {
      key: "Medium Dark",
      v: screenLabels?.skin_tone_medium_dark?.label_value || "Medium Dark",
      c: "#8E5A3D",
    },
    {
      key: "Dark",
      v: screenLabels?.skin_tone_dark?.label_value || "Dark",
      c: "#5F3825",
    },
    {
      key: "Very Dark",
      v: screenLabels?.skin_tone_very_dark?.label_value || "Very Dark",
      c: "#3E2417",
    },
  ];

  const extractProfileData = (user) => ({
    firstName: user?.first_name || "",
    lastName: user?.last_name || "",
    email: user?.email || "",
    secondaryEmail: user?.secondary_email || "",
    mobileNumber: user?.mobile_number || "",
    accessCode: user?.access_code || "",
    dob: user?.dob || "",
    age: user?.age || "",
    weight: user?.weight || "",
    weightUnit: user?.weight_unit || "kg",
    heightUnit: user?.height_unit || "cm",
    waistUnit: user?.waist_unit || "cm",
    height: user?.height || "",
    race: user?.race || "",
    gender: user?.gender || "",
    waist_circumference: user?.waist_circumference || "",
    diabetes: user?.diabetes === "No" ? "No" : user?.diabetes || "",
    smoking: user?.smoking || "",
    hypertension: user?.hypertension || "",
    timeZone: user?.time_zone || "",
    country: user?.country || "",
    profile_photo: user?.profile_photo,
    wellnessCategory: user?.wellness_category || [],
  });

  useEffect(() => {
    getUserDetails();
    getWellnessCat();
    getTimeZone();
  }, [getUserDetails, getTimeZone, getWellnessCat]);

  useEffect(() => {
    if (userDetails) {
      const profile = extractProfileData(userDetails);
      setProfileData(profile);

      const userDiabetes = userDetails?.diabetes;
      const ud = userDiabetes?.toLowerCase();
      setDiabetesType("");
      if (
        ud === "yes" ||
        userDiabetes === "Type 1" ||
        userDiabetes === "Type 2" ||
        userDiabetes === "Not Sure"
      ) {
        setDiabetesYesNo("1");
      } else if (ud === "no") {
        setDiabetesYesNo("2");
      } else if (ud === "not say") {
        setDiabetesYesNo("3");
      } else {
        setDiabetesYesNo("");
      }
    }
  }, [userDetails]);

  useEffect(() => {
    if (servings?.length) {
      const user = servings[0];
      updateSignupData({
        fruits: user.fruits_servings,
        vegetables: user.vegetables_servings,
        grains: user.grains_servings,
        sugaryFoods: user.sugaryfoods_servings,
        redMeat: user.redmeat_servings,
        fish: user.fish_servings,
        activity: user.activity,
      });
    }
  }, [servings]);

  const saveTimerRef = useRef(null);
  const latestStateRef = useRef({});

  const scheduleAutoSave = (delay = 600) => {
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    saveTimerRef.current = setTimeout(() => {
      autoSave();
    }, delay);
  };

  const handleInputChange = (field, value) => {
    setProfileData((prev) => ({ ...prev, [field]: value }));
    scheduleAutoSave(field === "age" ? 1000 : 600);
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const sizeKB = file.size / 1024;
      if (sizeKB > 15360) {
        window.showToast("error", "Maximum 15 MB Image Size is allowed!");
        e.target.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setImageFile(reader.result);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    } else {
      window.showToast(
        "error",
        "Invalid file type! Please select an image file.",
      );
      e.target.value = "";
    }
  };

  const handleCrop = () => {
    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas({
        maxWidth: 800, // optional resize
        maxHeight: 800, // optional resize
      });

      croppedCanvas.toBlob(
        async (blob) => {
          if (!blob) return;

          const previewBase64 = croppedCanvas.toDataURL("image/jpeg", 0.8);
          setSelectedImage(previewBase64);

          setShowCropModal(false);

          await uploadCropImg(blob);

          await getUserDetails();
        },
        "image/jpeg",
        0.8,
      );
    }
  };

  const handleCheckboxChange = (uuid) => {
    let selectedTopics = Array.isArray(profileData?.wellnessCategory)
      ? [...profileData.wellnessCategory]
      : [];

    if (selectedTopics.includes(uuid)) {
      selectedTopics = selectedTopics.filter((id) => id !== uuid);
    } else {
      selectedTopics.push(uuid);
    }

    setProfileData((prev) => ({ ...prev, wellnessCategory: selectedTopics }));
    scheduleAutoSave();
  };

  latestStateRef.current = {
    profileData,
    diabetesYesNo,
    diabetesType,
    selectedTimeZone,
    isEmailVerified,
  };

  const autoSave = async () => {
    const {
      profileData: pd,
      diabetesYesNo: dyn,
      diabetesType: dt,
      selectedTimeZone: stz,
      isEmailVerified: emailOk,
    } = latestStateRef.current;

    if (
      is4Life &&
      pd?.secondaryEmail &&
      !emailOk &&
      !userDetails?.secondary_email
    ) {
      return;
    }

    let formattedDob = pd.dob;
    if (formattedDob) {
      const d = new Date(formattedDob);
      if (!isNaN(d)) {
        formattedDob = `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;
      }
    }
    const { timeZone: tz, ...rest } = pd;

    const loginObj = storage.get("loginObj");
    const userId = loginObj?.userKey;
    const deviceId = storage.get("DeviceId") || storage.get("deviceId");
    const token = storage.get("accessToken");
    if (!userId || !deviceId) return;

    const payload = {
      userID: userId,
      deviceID: deviceId,
      role: loginObj?.role || 3,
      ...rest,
      dob: formattedDob,
      diabetes:
        dyn === "1" ? "Yes" : dyn === "2" ? "No" : dyn === "3" ? "Not say" : "",
      time_zone: stz || tz,
    };

    try {
      const response = await axios.post(urls.updateUserDetails, payload, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (response?.data?.status !== true) {
        window.showToast(
          "error",
          response?.data?.error || "Failed to save changes",
        );
      }
    } catch (err) {
      window.showToast(
        "error",
        err?.response?.data?.error || "Failed to save changes",
      );
    }
  };

  const servingsTimerRef = useRef(null);
  const latestServingsRef = useRef({});
  latestServingsRef.current = signupData || {};

  const autoSaveServings = async () => {
    const sd = latestServingsRef.current || {};
    const loginObj = storage.get("loginObj");
    const userId = loginObj?.userKey;
    const companyId = loginObj?.companyKey;
    const deviceId = storage.get("DeviceId") || storage.get("deviceId");
    const token = storage.get("accessToken");
    if (!userId || !deviceId) return;
    const payload = {
      deviceID: deviceId,
      companyKey: companyId,
      userKey: userId,
      role: loginObj?.role || 3,
      fruits: sd.fruits || "",
      vegetables: sd.vegetables || "",
      grains: sd.grains || "",
      sugaryfoods: sd.sugaryFoods || "",
      redmeat: sd.redMeat || "",
      fish: sd.fish || "",
      activity: sd.activity || "",
    };
    try {
      const response = await axios.post(urls.updateServings, payload, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (response?.data?.status !== true) {
        window.showToast(
          "error",
          response?.data?.error || "Failed to save changes",
        );
      }
    } catch (err) {
      window.showToast(
        "error",
        err?.response?.data?.error || "Failed to save changes",
      );
    }
  };

  const handleServingChange = (key, value) => {
    updateSignupData(key, value);
    if (servingsTimerRef.current) clearTimeout(servingsTimerRef.current);
    servingsTimerRef.current = setTimeout(() => {
      autoSaveServings();
    }, 600);
  };

  const servingOptions = ["0", "1", "2", "3", "4", "5+"];

  const nutritionQuestions = [
    {
      key: "fruits",
      icon: images.fruit,
      label:
        commonLabel?.fruits?.label_value ||
        "How many servings of fruit do you typically eat each day? (1 serving = ½ cup)",
    },
    {
      key: "vegetables",
      icon: images.vegetable,
      label:
        commonLabel?.vegetables?.label_value ||
        "How many servings of vegetables do you typically eat each day? (1 cup raw or ½ cup cooked)",
    },
    {
      key: "grains",
      icon: images.wholeGrain,
      label:
        commonLabel?.grains?.label_value ||
        "How many servings of whole grains do you typically eat each day? (Examples: ½ cup cooked rice or oatmeal, 1 slice whole wheat bread, or 1 cup whole grain cereal)",
    },
    {
      key: "sugaryFoods",
      icon: images.sugar,
      label:
        commonLabel?.sugaryFoods?.label_value ||
        "How many servings of sugary foods do you typically eat each day? (e.g., cookie, doughnut, cake)",
    },
    {
      key: "redMeat",
      icon: images.redMeat,
      label:
        commonLabel?.redMeat?.label_value ||
        "How many servings of red meat do you typically eat each week? (~3 oz, about the size of your palm)",
    },
    {
      key: "fish",
      icon: images.fish,
      label:
        commonLabel?.fish?.label_value ||
        "How many servings of fish do you typically eat each week? (~3 oz, about the size of your palm)",
    },
  ];

  const RenderLabel = ({
    label,
    fieldKey,
    required,
    formData,
    formSubmitted,
  }) => {
    const isFieldInvalid =
      required && formSubmitted && !formData?.[fieldKey]?.toString().trim();
    return (
      <label className="form-label question-label">
        {label} {isFieldInvalid && <span className="text-danger">*</span>}{" "}
      </label>
    );
  };

  const renderLabelWithValidation = (fieldKey, label, required = false) => (
    <RenderLabel
      label={label}
      fieldKey={fieldKey}
      required={required}
      formData={profileData}
      formSubmitted={formSubmitted}
    />
  );
  return (
    <>
      <div className="content-part">
        <div className="d-flex justify-content-center">
          <div className="profile-container">
            <div
              className="user-profile-image position-relative"
              onClick={() => document.getElementById("fileUpload").click()}
            >
              <img
                src={
                  imagePath + userDetails?.profile_photo ||
                  selectedImage ||
                  images.userImage
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.userImage;
                }}
                alt="user-image"
              />{" "}
              <label
                htmlFor="fileUpload"
                className="profile-upload-icon"
                onClick={(e) => e.stopPropagation()}
              >
                <i className="fa fa-camera"></i>
              </label>
            </div>
            <input
              type="file"
              id="fileUpload"
              accept="image/*"
              hidden
              onChange={handleImageChange}
            />
          </div>
        </div>

        <div className="mt-4">
          <div className="row">
            <div className="col-6">
              <div className="form-group mb-3">
                {renderLabelWithValidation(
                  "firstName",
                  authLabel?.first_name?.label_value || "First Name",
                  true,
                )}

                <input
                  type="text"
                  className="form-control wrInputText"
                  value={profileData?.firstName || ""}
                  onChange={(e) =>
                    handleInputChange("firstName", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group mb-3">
                {renderLabelWithValidation(
                  "lastName",
                  authLabel?.last_name?.label_value || "Last Name",
                  true,
                )}
                <input
                  type="text"
                  className="form-control wrInputText"
                  value={profileData?.lastName || ""}
                  onChange={(e) =>
                    handleInputChange("lastName", e.target.value)
                  }
                />
              </div>
            </div>
          </div>

          <div className="row">
            {!is4Life && (
              <div className="col-md-6">
                <div className="form-group mb-3">
                  {renderLabelWithValidation(
                    "email",
                    authLabel?.email?.label_value || "Email",
                    false,
                  )}
                  <div className="mb-3 position-relative">
                    <input
                      type="email"
                      className="form-control wrInputText"
                      placeholder={
                        authLabel?.enter_your_email?.label_value ||
                        "Enter e-mail"
                      }
                      value={profileData?.email || ""}
                      disabled
                    />
                    <span className="email-icon" id="basic-addon1">
                      <Mail size={20} />
                    </span>
                  </div>
                </div>
              </div>
            )}

            {is4Life && (
              <div className="col-md-6">
                <div className="form-group mb-2">
                  <div className="d-flex align-items-center justify-content-between">
                    {renderLabelWithValidation(
                      "email",
                      authLabel?.email?.label_value || "Email",
                      false,
                    )}

                    {userDetails?.secondary_email || isEmailVerified ? (
                      <span className="text-success fw-bold">
                        {screenLabels?.verified?.label_value || "Verified"}
                      </span>
                    ) : (
                      <span
                        className="text-primary fw-semibold"
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          const success = await fourLifeEmailOTP({
                            email: profileData?.secondaryEmail,
                            module: "Signup",
                          });

                          if (success) {
                            setShowOtpModal(true);
                          }
                        }}
                      >
                        {screenLabels?.verify?.label_value || "Verify"}
                      </span>
                    )}
                  </div>

                  <div className=" position-relative">
                    <input
                      type="email"
                      className="form-control wrInputText"
                      placeholder={
                        authLabel?.enter_your_email?.label_value ||
                        "Enter e-mail"
                      }
                      value={
                        is4Life
                          ? profileData?.secondaryEmail
                          : profileData?.userEmail || ""
                      }
                      onChange={(e) => {
                        handleInputChange("secondaryEmail", e.target.value);

                        setIsEmailVerified(false);
                      }}
                      // disabled={!!profileData?.secondaryEmail}
                      // disabled={isEmailVerified}
                      // disabled={!!userDetails?.secondary_email}
                      disabled={
                        !!userDetails?.secondary_email || isEmailVerified
                      }
                    />
                    <span className="email-icon" id="basic-addon1">
                      <Mail size={20} />
                    </span>
                  </div>
                  {profileData?.secondaryEmail &&
                    !isEmailVerified &&
                    !userDetails?.secondary_email && (
                      <small className="text-danger">
                        {screenLabels?.please_verify_email_before_saving
                          ?.label_value ||
                          "Please verify your email before saving."}
                      </small>
                    )}
                </div>
              </div>
            )}

            {!is4Life && (
              <div className="col-md-6">
                <div className="form-group mb-3">
                  {renderLabelWithValidation(
                    "mobileNumber",
                    authLabel?.phone_number?.label_value || "Phone number",
                    false,
                  )}
                  <PhoneNumberInput
                    value={profileData?.mobileNumber}
                    onChange={(formattedValue) => {
                      handleInputChange("mobileNumber", formattedValue);
                    }}
                  />
                </div>
              </div>
            )}
            <div className="col-md-6">
              <div className="form-group mb-3">
                {renderLabelWithValidation(
                  "age",
                  authLabel?.what_is_your_age?.label_value || "Age",
                  true,
                )}
                <input
                  type="number"
                  placeholder={
                    screenLabels?.enter_your_age?.label_value ||
                    "Enter your age"
                  }
                  className="form-control wrInputText"
                  value={profileData?.age || ""}
                  onChange={(e) => handleInputChange("age", e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* <div className="row">
            <div
              className="form-group mb-2 position-relative"
              ref={calendarRef}
            >
              {renderLabelWithValidation(
                "dob",
                `${authLabel?.date_of_birth?.label_value || "Date of birth"} (${authLabel?.min_age_text?.label_value ||
                "must be at least 18 years old"
                })`,
                true
              )}

              <div className="position-relative">
                <div
                  className="form-control wrInputText pe-5"
                  onClick={() => setShowCalendar(!showCalendar)}
                  style={{ cursor: "pointer", backgroundColor: "#fff" }}
                >
                  {profileData?.dob
                    ? new Date(profileData.dob).toLocaleDateString("en-GB")
                    : "Select date"}
                </div>

                <CalendarDays
                  size={18}
                  className="position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                  pointerEvents="none"
                />
              </div>

              {showCalendar && (
                <div
                  className="position-absolute bg-white mt-1"
                  style={{ zIndex: 3 }}
                >
                  <Calendar
                    mode="dob"
                    value={profileData?.dob}
                    onDateChange={(dateObj) => {
                      handleInputChange("dob", dateObj);
                      setShowCalendar(false);
                    }}
                  />
                </div>
              )}
            </div>
          </div> */}
          <h5 className="my-2 mb-3">
            {authLabel?.physical_information?.label_value ||
              "Physical Information"}
          </h5>

          <div className="form-group mt-3">
            {renderLabelWithValidation(
              "gender",
              authLabel?.fourLife_gender_at_birth?.label_value ||
              "Gender At Birth",
              true,
            )}
            <div className="d-flex w-100 gap-3">
              {/* Male */}
              <div
                className={`custom-checkbox custom-selection position-relative w-50 ${profileData.gender === "male" ? "active-selection" : ""
                  }`}
                onClick={() => handleInputChange("gender", "male")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="input-image">
                      <img src={images.maleImg} alt="male" />
                    </div>
                    <p className="mb-0 fw-semibold">
                      {authLabel?.male?.label_value || "Male"}
                    </p>
                  </div>

                  <input
                    type="radio"
                    id="maleOption"
                    name="gender"
                    value="male"
                    checked={profileData.gender === "male"}
                    onChange={() => handleInputChange("gender", "male")}
                    hidden
                  />

                  <label
                    htmlFor="maleOption"
                    className="custom-label-left"
                  ></label>
                </div>
              </div>

              {/* Female */}
              <div
                className={`custom-checkbox custom-selection position-relative w-50 ${profileData.gender === "female" ? "active-selection" : ""
                  }`}
                onClick={() => handleInputChange("gender", "female")}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="input-image">
                      <img src={images.femaleImg} alt="female" />
                    </div>
                    <p className="mb-0 fw-semibold">
                      {authLabel?.female?.label_value || "Female"}
                    </p>
                  </div>

                  <input
                    type="radio"
                    id="femaleOption"
                    name="gender"
                    value="female"
                    checked={profileData.gender === "female"}
                    onChange={() => handleInputChange("gender", "female")}
                    hidden
                  />

                  <label
                    htmlFor="femaleOption"
                    className="custom-label-left"
                  ></label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mt-3">
            {renderLabelWithValidation(
              "weight",
              authLabel?.fourLife_weight?.label_value || "Weight",
              true,
            )}
            <input
              type="text"
              className="form-control wrInputText"
              placeholder={
                authLabel?.enter_weight?.label_value || "Enter weight"
              }
              value={
                profileData?.weight && profileData?.weightUnit
                  ? `${profileData.weight}\u00A0\u00A0${profileData.weightUnit}`
                  : ""
              }
              readOnly
              onClick={() => setWeightModal(true)}
            />
          </div>

          <div className="form-group mt-3">
            {renderLabelWithValidation(
              "height",
              authLabel?.fourLife_height?.label_value || "Height",
              true,
            )}
            <div className="input-group">
              <input
                type="text"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_height?.label_value || "Enter height"
                }
                value={
                  `${profileData?.height} ${profileData?.heightUnit} ` || ""
                }
                readOnly
                onClick={() => setShowHeightModal(true)}
              />
            </div>
          </div>

          <div className="form-group mt-3">
            {renderLabelWithValidation(
              "waist_circumference",
              authLabel?.waist_circumference?.label_value ||
              "Waist Circumference",
              true,
            )}
            <div className="input-group">
              <input
                type="text"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_value_in_cm?.label_value ||
                  "Enter value in cm"
                }
                value={
                  profileData?.waist_circumference && profileData?.waistUnit
                    ? `${profileData.waist_circumference}\u00A0\u00A0${profileData.waistUnit}`
                    : ""
                }
                readOnly
                onClick={() => setShowWaistModal(true)}
              />
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 mb-3">
            <div className="form-group">
              {renderLabelWithValidation(
                "race",
                authLabel?.skin_text?.label_value || "What is your skin tone?",
                true,
              )}
              <div className="d-flex flex-wrap gap-2 mt-1">
                {SKIN_TONES.map((tone) => {
                  const active = profileData?.race === tone.key;
                  return (
                    <div
                      key={tone.key}
                      onClick={() => handleInputChange("race", tone.key)}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                        padding: "8px 6px",
                        borderRadius: 12,
                        border: active
                          ? "2px solid var(--primaryColor, #11a8df)"
                          : "2px solid #e2e8f0",
                        background: active ? "rgba(17,168,223,0.06)" : "#fff",
                        flex: "1 1 calc(25% - 8px)",
                        maxWidth: "calc(25% - 8px)",
                        boxSizing: "border-box",
                        transition: "all .15s ease",
                      }}
                    >
                      <span
                        style={{
                          width: 34,
                          height: 34,
                          borderRadius: "50%",
                          background: tone.c,
                          border: "1px solid rgba(0,0,0,0.12)",
                          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.18)",
                        }}
                      />
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 500,
                          textAlign: "center",
                          lineHeight: 1.2,
                          color: "#475569",
                        }}
                      >
                        {tone.v}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="form-group">
              {renderLabelWithValidation(
                "timeZone",
                authLabel?.time_zone?.label_value || "TimeZone",
                true,
              )}
              <Select
                options={timeZone?.map((item) => ({
                  value: item.zone_name,
                  label: item.zone_name,
                }))}
                placeholder={
                  screenLabels?.select_timezone?.label_value ||
                  "Select Timezone"
                }
                value={
                  selectedTimeZone
                    ? { value: selectedTimeZone, label: selectedTimeZone }
                    : profileData.timeZone
                      ? {
                        value: profileData.timeZone,
                        label: profileData.timeZone,
                      }
                      : null
                }
                onChange={(option) => {
                  setSelectedTimeZone(option.value);
                  handleInputChange("timeZone", option.value);
                }}
              />
            </div>
          </div>

          <div className="col-md-6">
            {/* {is4Life && ( */}
            <div className="mb-2">
              <div className="form-group">
                <label className="form-label question-label">
                  {authLabel?.country?.label_value || "Country"}
                </label>

                <Select
                  className="edit-profile-select"
                  classNamePrefix="react-select"
                  options={countryOptions}
                  placeholder={
                    authLabel?.select_country?.label_value || "Select Country"
                  }
                  value={
                    profileData.country
                      ? countryOptions.find(
                        (c) => c.value === profileData.country,
                      )
                      : null
                  }
                  onChange={(option) =>
                    handleInputChange("country", option?.value || "")
                  }
                />
              </div>
            </div>
            {/* )} */}
          </div>
        </div>

        <h5 className="mt-3 mb-3">
          <Stethoscope />
          &nbsp;
          {authLabel?.wellness_information?.label_value ||
            "Wellness information"}
        </h5>

        <div className="row">
          <div className="col-12 mb-3">
            <div className="form-group">
              {renderLabelWithValidation(
                "diabetes",
                authLabel?.blood_sugar?.label_value ||
                "Are you managing blood sugar levels?",
                true,
              )}
              <div className="d-flex align-items-center gap-2 mt-1">
                <div className="input-image">
                  <img src={images.diabetic} alt="diabetes" />
                </div>
                <div className="d-flex w-100 gap-3 flex-wrap">
                  {[
                    {
                      label: authLabel?.yes?.label_value || "Yes",
                      code: "1",
                    },
                    {
                      label: authLabel?.no?.label_value || "No",
                      code: "2",
                    },
                    {
                      label:
                        authLabel?.prefer_not_to_say?.label_value ||
                        "Prefer not to say",
                      code: "3",
                    },
                  ].map(({ label, code }) => (
                    <div
                      key={code}
                      className={`custom-checkbox custom-selection position-relative flex-grow-1 ${diabetesYesNo === code ? "active-selection" : ""
                        }`}
                      onClick={() => {
                        setDiabetesYesNo(code);
                        setDiabetesType("");
                        if (code === "1") {
                          handleInputChange("diabetes", "Yes");
                        } else if (code === "2") {
                          handleInputChange("diabetes", "No");
                        } else if (code === "3") {
                          handleInputChange("diabetes", "Not say");
                        } else {
                          handleInputChange("diabetes", "");
                        }
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="m-0 fw-semibold">{label}</p>
                        <input
                          type="radio"
                          id={`profile-diabetes-${code}`}
                          name="profile-diabetes"
                          value={code}
                          checked={diabetesYesNo === code}
                          onChange={() => { }}
                          hidden
                        />
                        <label
                          htmlFor={`profile-diabetes-${code}`}
                          className="custom-label-left mb-0"
                        ></label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="col-md-6 mb-3">
            <div className="form-group">
              {renderLabelWithValidation(
                "hypertension",
                authLabel?.do_you_have_hypertension?.label_value ||
                "Do you have hypertension (high blood pressure)?",
                true,
              )}
              <div className="d-flex align-items-center gap-2">
                <div className="input-image">
                  <img src={images.bloodPressure} alt="hypertension" />
                </div>
                <select
                  className="form-select"
                  value={profileData?.hypertension || ""}
                  onChange={(e) =>
                    handleInputChange("hypertension", e.target.value)
                  }
                >
                  <option value="" disabled>
                    {authLabel?.select_option?.label_value || "Select Option"}
                  </option>
                  <option value="Yes">
                    {authLabel?.yes?.label_value || "Yes"}
                  </option>
                  <option value="No">
                    {authLabel?.no?.label_value || "No"}
                  </option>
                </select>
              </div>
            </div>
          </div> */}
          <div className="col-12 form-group mb-3">
            {renderLabelWithValidation(
              "smoking",
              authLabel?.tobacco_or_nicotine?.label_value ||
              "Do you currently use tobacco or nicotine products?",
              true,
            )}
            <div className="d-flex align-items-center gap-2 mt-1">
              <div className="input-image">
                <img src={images.smoke} alt="smoke" className="mb-2" />
              </div>
              <div className="d-flex w-100 gap-3 flex-wrap">
                {[
                  { label: authLabel?.yes?.label_value || "Yes", value: "Yes" },
                  { label: authLabel?.no?.label_value || "No", value: "No" },
                  {
                    label:
                      authLabel?.prefer_not_to_say?.label_value ||
                      "Prefer not to say",
                    value: "Not say",
                  },
                ].map(({ label, value }) => (
                  <div
                    key={value}
                    className={`custom-checkbox custom-selection position-relative flex-grow-1 ${profileData?.smoking === value ? "active-selection" : ""
                      }`}
                    onClick={() => handleInputChange("smoking", value)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="m-0 fw-semibold">{label}</p>
                      <input
                        type="radio"
                        id={`profile-smoking-${value}`}
                        name="profile-smoking"
                        value={value}
                        checked={profileData?.smoking === value}
                        onChange={() => handleInputChange("smoking", value)}
                        hidden
                      />
                      <label
                        htmlFor={`profile-smoking-${value}`}
                        className="custom-label-left mb-0"
                      ></label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {is4Life && (
          <div className="mt-4 mb-4">
            <h5 className="mb-3 d-flex align-items-center gap-2">
              <Activity size={18} />
              {authLabel?.lifestyle_details?.label_value || "Lifestyle Details"}
            </h5>

            {nutritionQuestions.map((q) => (
              <div className="mb-30px" key={q.key}>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-image">
                    <img src={q.icon} alt="icon" />
                  </div>
                  <label
                    className="form-label question-label"
                    style={{ fontSize: "13px" }}
                  >
                    {q.label}
                  </label>
                </div>

                <select
                  className="form-select mt-1"
                  value={signupData?.[q.key] || ""}
                  onChange={(e) => handleServingChange(q.key, e.target.value)}
                >
                  <option value="" disabled>
                    {authLabel?.select_option?.label_value ||
                      "Select Option"}
                  </option>
                  {servingOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            <h5 className="mt-3 mb-3 d-flex align-items-center gap-2">
              <Activity size={18} />
              {screenLabels?.weekly_activity?.label_value || "Weekly Activity"}
            </h5>

            <div className="mb-30px">
              <div className="d-flex align-items-center gap-2 mb-2">
                <div className="input-image">
                  <img src={images.activity} alt="activity" />
                </div>
                <label
                  className="form-label question-label"
                  style={{ fontSize: "13px" }}
                >
                  {commonLabel?.activity?.label_value ||
                    "How many minutes of moderate or vigorous physical activity do you get each week?(Moderate: breathing harder, can talk in short sentences. Vigorous: heavy breathing, few words at a time.)"}
                </label>
              </div>

              <select
                className="form-select mt-1"
                value={signupData?.activity || ""}
                onChange={(e) =>
                  handleServingChange("activity", e.target.value)
                }
              >
                <option value="" disabled>
                  {authLabel?.select_option?.label_value || "Select Option"}
                </option>
                {["Less than 50", "51 - 100", "101 - 150", "More than 150"].map(
                  (opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ),
                )}
              </select>
            </div>
          </div>
        )}

        {!is4Life ? (
          <>
            <h5 className="mt-1 mb-0">
              {renderLabelWithValidation(
                "wellness_categories",
                authLabel?.wellness_categories?.label_value ||
                "Wellness Interests",
                true,
              )}
            </h5>

            <div className="d-flex flex-column gap-2 mt-2">
              {wellnessCat?.list?.map((cat) => {
                const isSelected = profileData?.wellnessCategory?.includes(
                  cat.uuid,
                );
                const borderColor = isSelected
                  ? "transparent"
                  : "var(--primaryColor)";
                const backgroundColor = isSelected
                  ? "var(--primaryColor)"
                  : "transparent";
                const checkColor = isSelected ? "white" : "transparent";

                const normalize = (str) =>
                  str
                    ?.toLowerCase()
                    .replace(/&/g, "")
                    .replace(/[^a-z0-9\s_]/g, "")
                    .replace(/\s+/g, "_")
                    .replace(/_+/g, "_")
                    .trim();

                const normalizedCatName = normalize(cat.category_name);

                const allKeys = [
                  ...Object.keys(screenLabels || {}),
                  ...Object.keys(authLabel || {}),
                ];

                const matchedKey = allKeys.find(
                  (key) => normalize(key) === normalizedCatName,
                );

                const label =
                  screenLabels?.[matchedKey]?.label_value ||
                  authLabel?.[matchedKey]?.label_value ||
                  cat.category_name;

                return (
                  <div
                    key={cat.uuid}
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleCheckboxChange(cat.uuid)}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "22px",
                        height: "22px",
                        borderRadius: "50%",
                        border: `2px solid ${borderColor}`,
                        backgroundColor,
                        transition: "all 0.2s ease-in-out",
                      }}
                    >
                      <Check size={18} color={checkColor} strokeWidth={3} />
                    </div>
                    <span className="fw-semibold mb-0">{label}</span>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <>
            <h5 className="mt-3 mb-3">
              {renderLabelWithValidation(
                "wellness_categories",
                screenLabels?.your_top_health_priorities?.label_value ||
                "Your Top Health Priorities",
                true,
              )}
            </h5>

            <div className="d-flex flex-column gap-2">
              {wellnessCat?.other_list?.map((cat) => {
                const isSelected = profileData?.wellnessCategory?.includes(
                  cat.uuid,
                );
                const borderColor = isSelected
                  ? "transparent"
                  : "var(--primaryColor)";
                const backgroundColor = isSelected
                  ? "var(--primaryColor)"
                  : "transparent";
                const checkColor = isSelected ? "white" : "transparent";

                const normalize = (str) =>
                  str
                    ?.toLowerCase()
                    .replace(/&/g, "")
                    .replace(/[^a-z0-9\s_]/g, "")
                    .replace(/\s+/g, "_")
                    .replace(/_+/g, "_")
                    .trim();

                const normalizedCatName = normalize(cat.category_name);

                const allKeys = [
                  ...Object.keys(screenLabels || {}),
                  ...Object.keys(authLabel || {}),
                ];

                const matchedKey = allKeys.find(
                  (key) => normalize(key) === normalizedCatName,
                );

                const label =
                  screenLabels?.[matchedKey]?.label_value ||
                  authLabel?.[matchedKey]?.label_value ||
                  cat.category_name;
                return (
                  <div
                    key={cat.uuid}
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleCheckboxChange(cat.uuid)}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "22px",
                        height: "22px",
                        borderRadius: "50%",
                        border: `2px solid ${borderColor}`,
                        backgroundColor,
                        transition: "all 0.2s ease-in-out",
                      }}
                    >
                      <Check size={18} color={checkColor} strokeWidth={3} />
                    </div>
                    <span className="fw-semibold mb-0">{label}</span>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {showCropModal && (
          <div className="container modal-backdrop-custom">
            <div className="crop-modal p-3 bg-white rounded modal-sm shadow-lg position-relative">
              <div className="d-flex mb-3 align-items-center justify-content-between">
                <h5 className="mb-0">
                  {screenLabels?.crop_img?.label_value || "Crop Image"}
                </h5>
                <div
                  className="btn-close-modal"
                  onClick={() => setShowCropModal(false)}
                  aria-label="Close"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.5 0C10.0277 0 7.61099 0.733112 5.55538 2.10663C3.49976 3.48015 1.89761 5.43238 0.951511 7.71645C0.0054161 10.0005 -0.242126 12.5139 0.24019 14.9386C0.722505 17.3634 1.91301 19.5907 3.66117 21.3388C5.40933 23.087 7.63661 24.2775 10.0614 24.7598C12.4861 25.2421 14.9995 24.9946 17.2835 24.0485C19.5676 23.1024 21.5199 21.5002 22.8934 19.4446C24.2669 17.389 25 14.9723 25 12.5C24.9961 9.18599 23.6779 6.00884 21.3345 3.66548C18.9912 1.32213 15.814 0.00390963 12.5 0ZM17.3205 15.7148C17.429 15.8196 17.5156 15.945 17.5751 16.0836C17.6347 16.2223 17.666 16.3714 17.6673 16.5223C17.6686 16.6732 17.6399 16.8228 17.5828 16.9624C17.5256 17.1021 17.4412 17.229 17.3345 17.3357C17.2278 17.4424 17.101 17.5267 16.9613 17.5839C16.8217 17.641 16.672 17.6698 16.5211 17.6685C16.3703 17.6672 16.2211 17.6358 16.0825 17.5762C15.9439 17.5167 15.8185 17.4301 15.7136 17.3216L12.5 14.1068L9.28637 17.3216C9.07205 17.5286 8.785 17.6431 8.48705 17.6405C8.1891 17.6379 7.90408 17.5184 7.69339 17.3077C7.4827 17.0971 7.36319 16.812 7.3606 16.5141C7.35801 16.2161 7.47255 15.9291 7.67955 15.7148L10.8932 12.5L7.67955 9.28522C7.57101 9.1804 7.48444 9.05501 7.42489 8.91637C7.36533 8.77773 7.33399 8.62861 7.33267 8.47773C7.33136 8.32684 7.36011 8.17721 7.41725 8.03755C7.47439 7.8979 7.55877 7.77102 7.66546 7.66432C7.77216 7.55763 7.89904 7.47325 8.03869 7.41611C8.17835 7.35897 8.32798 7.33022 8.47887 7.33153C8.62975 7.33284 8.77887 7.36419 8.91751 7.42375C9.05615 7.4833 9.18154 7.56987 9.28637 7.67841L12.5 10.8932L15.7136 7.67841C15.8185 7.56987 15.9439 7.4833 16.0825 7.42375C16.2211 7.36419 16.3703 7.33284 16.5211 7.33153C16.672 7.33022 16.8217 7.35897 16.9613 7.41611C17.101 7.47325 17.2278 7.55763 17.3345 7.66432C17.4412 7.77102 17.5256 7.8979 17.5828 8.03755C17.6399 8.17721 17.6686 8.32684 17.6673 8.47773C17.666 8.62861 17.6347 8.77773 17.5751 8.91637C17.5156 9.05501 17.429 9.1804 17.3205 9.28522L14.1068 12.5L17.3205 15.7148Z"
                      fill="#FF584A"
                    ></path>
                  </svg>
                </div>
              </div>

              <Cropper
                src={imageFile}
                style={{ height: 300, width: "100%" }}
                initialAspectRatio={1}
                aspectRatio={1}
                guides={false}
                viewMode={2}
                responsive={true}
                autoCropArea={1}
                minCropBoxHeight={200}
                onInitialized={(instance) => setCropper(instance)}
              />

              <div className="d-flex justify-content-end gap-3 mt-4">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    if (cropper) cropper.reset();
                  }}
                >
                  {screenLabels?.restore?.label_value || "Restore"}
                </button>
                <button className="btn btn-primary" onClick={handleCrop}>
                  {screenLabels?.upload?.label_value || "Upload"}
                </button>
              </div>
            </div>
          </div>
        )}

        <WeightModal
          show={showWeightModal}
          onClose={() => setWeightModal(false)}
          initialWeight={profileData.weight}
          initialUnit={profileData.weightUnit}
          onSave={({ weight, weightUnit }) => {
            if (weightUnit === "kg") {
              if (weight < 20 || weight > 300) {
                window.showToast("error", "Weight must be between 20–300 kg.");
                return;
              }
            } else if (weightUnit === "lbs") {
              if (weight < 44 || weight > 661) {
                window.showToast("error", "Weight must be between 44–661 lbs.");
                return;
              }
            }
            setProfileData((prev) => ({
              ...prev,
              weight,
              weightUnit,
            }));
            scheduleAutoSave();
            setWeightModal(false);
          }}
        />

        <HeightModal
          show={showHeightModal}
          onClose={() => setShowHeightModal(false)}
          initialHeight={profileData.height}
          initialUnit={profileData.heightUnit}
          onSave={({ height, heightUnit }) => {
            if (heightUnit === "cm") {
              if (height < 100 || height > 250) {
                window.showToast("error", "Height must be between 100–250 cm.");
                return;
              }
            } else if (heightUnit === "feet") {
              if (height < 3.3 || height > 8.2) {
                window.showToast(
                  "error",
                  "Height must be between 3.3–8.2 feet.",
                );
                return;
              }
            }
            setProfileData((prev) => ({
              ...prev,
              height,
              heightUnit,
            }));
            scheduleAutoSave();
            setShowHeightModal(false);
          }}
        />

        <WaistModal
          show={showWaistModal}
          onClose={() => setShowWaistModal(false)}
          initialWaist={profileData.waist_circumference}
          initialUnit={profileData.waistUnit}
          onSave={({ waist_circumference, waistUnit }) => {
            setProfileData((prev) => ({
              ...prev,
              waist_circumference,
              waistUnit,
            }));
            scheduleAutoSave();
            setShowWaistModal(false);
          }}
        />
        <VerifyOtpModal
          show={showOtpModal}
          email={profileData.secondaryEmail}
          onClose={() => setShowOtpModal(false)}
          onSuccess={() => {
            updateSignupData("secondaryEmail", profileData.secondaryEmail);
            setIsEmailVerified(true);
            latestStateRef.current = { ...latestStateRef.current, isEmailVerified: true };
            autoSave();
            setShowOtpModal(false);
          }}
        />
      </div>
    </>
  );
};

export default UserProfileEdit;
